export default __webpack_public_path__ + "static/media/next-arrow-no-outline.c39565f8.svg";